const App = {
  SetBackground: () => {
    $("[setBackground]").each(function () {
      var background = $(this).attr("setBackground");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-size": "cover",
        "background-position": "center center",
      });
    });
    $("[setBackgroundRepeat]").each(function () {
      var background = $(this).attr("setBackgroundRepeat");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-repeat": "repeat",
      });
    });
  },
  EqualHeightElement: (el) => {
    let height = 0;
    let thisHeight = 0;
    $(el).each(function () {
      thisHeight = $(this).height();
      if (thisHeight > height) {
        height = thisHeight;
      }
    });
    $(el).height(height);
  },
  ScrollTo: (y) => {
    $("html, body").animate(
      {
        scrollTop: y,
      },
      1000
    );
  },
  Init: () => {
    App.ScrollTo();
    App.SetBackground();
  },
};

function InitSlider() {
  if ($(".product-details-slider").length) {
    var thumbsSlide = new Swiper(".thumbs", {
      spaceBetween: 15,
      slidesPerView: 3,
    });
    var gallerySlide = new Swiper(".gallery", {
      spaceBetween: 10,
      thumbs: {
        swiper: thumbsSlide,
      },
    });
  }

  var exploreOurServicesSlide = new Swiper(
    ".explore-our-services .swiper-container",
    {
      speed: 1500,
      slidesPerView: 4,
      spaceBetween: 0,
      autoplay: {
        delay: 7000,
      },
      navigation: {
        clickable: !0,
        nextEl: ".explore-our-services .swiper-next",
        prevEl: ".explore-our-services .swiper-prev",
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        576: {
          slidesPerView: 1,
        },
      },
    }
  );
  var exploreOurServicesSlide = new Swiper(".our-customers .swiper-container", {
    speed: 1500,
    slidesPerView: 3,
    spaceBetween: 0,
    autoplay: {
      delay: 7000,
    },
    navigation: {
      clickable: !0,
      nextEl: ".our-customers .swiper-next",
      prevEl: ".our-customers .swiper-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 1,
      },
    },
  });

  var testimonialsSlide = new Swiper(".what-people-saying .swiper-container", {
    speed: 1500,
    slidesPerView: 2,
    spaceBetween: 30,
    autoplay: {
      delay: 7000,
    },
    navigation: {
      clickable: !0,
      nextEl: ".what-people-saying .swiper-next",
      prevEl: ".what-people-saying .swiper-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      576: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
    pagination: {
      el: ".what-people-saying .swiper-pagination",
      clickable: !0,
      type: "bullets",
    },
  });

  $(".list-products .swiper-container").each(function (index, element) {
    var $this = $(this);
    $this.addClass("tri-instance-" + index);
    $this
      .parents(".list-products")
      .find(".swiper-prev")
      .addClass("btn-prev-" + index);
    $this
      .parents(".list-products")
      .find(".swiper-next")
      .addClass("btn-next-" + index);
    $this
      .parents(".list-products")
      .find(".swiper-pagination")
      .addClass("swiper-pagination-" + index);
    var swiper = new Swiper(".tri-instance-" + index, {
      lazy: true,
      speed: 1205,
      spaceBetween: 30,
      autoplay: {
        delay: 7000,
      },
      slidesPerView: 4,
      observer: true,
      observeParents: true,
      breakpoints: {
        992: {
          spaceBetween: 30,
          slidesPerView: 3,
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        575: {
          spaceBetween: 20,
          slidesPerView: 1,
        },
      },
      navigation: {
        nextEl: ".btn-next-" + index,
        prevEl: ".btn-prev-" + index,
      },
      pagination: {
        el: ".swiper-pagination-" + index,
        clickable: !0,
        type: "bullets",
      },
    });
  });
}

function Headers() {
  $(document).on("click", ".toggle-btn", function () {
    $(this).toggleClass("active");
    $(".mobile-nav-inner").toggleClass("active");
    $(".header .overlay").toggleClass("active");
  });
  $(document).on("click", ".header .overlay", function () {
    $(this).removeClass("active");
    $(".mobile-nav-inner").removeClass("active");
    $(".toggle-btn").removeClass("active");
  });

  $(document).on(
    "click",
    ".header .has-dropdown .icon-dropdown",
    function (event) {
      event.preventDefault();
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).parents(".has-dropdown").removeClass("active");
        $(this).parents(".has-dropdown").find(".nav-sub").slideUp();
      } else {
        $(".header .has-dropdown .nav-sub").slideUp();
        $(".header .has-dropdown .icon-dropdown").removeClass("active");
        $(".header .has-dropdown").removeClass("active");
        $(this)
          .toggleClass("active")
          .parents(".has-dropdown")
          .find(".nav-sub")
          .slideDown();
        $(this).parents(".has-dropdown").toggleClass("active");
      }
    }
  );
}
//mapping
function mappings() {
  if ($(".header").length) {
    var headerTop = new MappingListener({
      selector: ".header .header-top",
      mobileWrapper: ".mobile-nav-inner",
      mobileMethod: "appendTo",
      desktopWrapper: ".header",
      desktopMethod: "prependTo",
      breakpoint: 1280,
    }).watch();

    var moveNav = new MappingListener({
      selector: ".header .menu",
      mobileWrapper: ".mobile-nav-inner",
      mobileMethod: "appendTo",
      desktopWrapper: ".header .logo-box",
      desktopMethod: "insertAfter",
      breakpoint: 1280,
    }).watch();

    var moveBtn = new MappingListener({
      selector: ".header .btn-wrap",
      mobileWrapper: ".mobile-nav-inner",
      mobileMethod: "appendTo",
      desktopWrapper: ".header .cart",
      desktopMethod: "insertBefore",
      breakpoint: 1280,
    }).watch();
  }
}
function accordion() {
  if ($(".accordions").length) {
    $(".accordion-item.active").find(".accordion-content").show();
    $(".accordion-heading").on("click", function () {
      if (!$(this).parent().is(".active")) {
        $(this)
          .parent()
          .toggleClass("active")
          .children(".accordion-content")
          .slideToggle(500)
          .parent()
          .siblings(".active")
          .removeClass("active")
          .children(".accordion-content")
          .slideToggle(500);
      } else {
        $(this).parent().toggleClass("active");
        $(this).next().slideToggle(500);
      }
    });
  }
}
function jarallax() {
  $(".jarallax").jarallax({
    speed: 0.2,
    disableParallax: / iPad | iPhone | iPod | Android /,
    disableVideo: / iPad | iPhone | iPod | Android /,
  });
}

function myTabs() {
  $(".my-tabs").each(function () {
    var $this = $(this);
    $this.find(".tabs-nav li:first").addClass("active");
    $this.find(".tab-content:first").show();
    $this.find(".tabs-nav li").click(function () {
      var corresponding = $(this).data("tab");
      $this.find(".tab-content").hide();
      $this.find(".tab-content." + corresponding).show();
      $this.find(".tabs-nav li").removeClass("active");
      $(this).addClass("active");
      $(".slick-container").slick("setPosition", 0);
    });
  });
}
function selectUi() {
  $(".dropdown").on("click", ".dropdown-select", function () {
    if ($(this).parents(".dropdown").hasClass("open")) {
      $(this).parents(".dropdown").removeClass("open");
      $(this).siblings(".dropdown-list").hide();
    } else {
      $(".dropdown").removeClass("open");
      $(this).parents(".dropdown").addClass("open");
      $(".dropdown-list").hide();
      $(this).siblings(".dropdown-list").show();
    }
  });
  var allOptions = $(".dropdown-list").children(".dropdown-item");
  $(".dropdown-list").on("click", ".dropdown-item", function () {
    allOptions.removeClass("selected");
    $(this).addClass("selected");
    $(this)
      .parents(".dropdown")
      .find(".dropdown-selected")
      .css("color", "#212429")
      .html($(this).html());

    $(this).parents(".dropdown-list").toggle();
    $(this).parents(".dropdown").toggleClass("open");
    $("input#inputInit").val($(this).data("val"));
  });
  var $menu = $(".dropdown");

  $(document).mouseup(function (e) {
    if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
      $menu.removeClass("open");
      $menu.find(".dropdown-list").hide();
    }
  });
}

function checkWidth() {
  var $window = $(window);
  var windowsize = $window.width();
  if (windowsize >= 768) {
    $(".sidebar-inner").removeAttr("style");
  }
  if (windowsize >= 1200) {
    $(".header").find(".nav-sub").removeAttr("style");
    $(".header").find(".nav-child").removeAttr("style");
  }
  if (windowsize >= 1200) {
    $(".header .overlay").removeClass("active");
    $(
      ".header .mobile-nav-inner,.has-dropdown,.icon-dropdown,.icon-dropdown-2,.has-child"
    ).removeClass("active");
    $(".has-child:first-child").addClass("active");
    $(".has-child:first-child .nav-child").addClass("is-hover");
  }

  setTimeout(function () {
    $(".btn-position").each(function () {
      var imgHeight = $(this).find(".box-img").outerHeight();
      var btnHeight = $(this).find(".swiper-next").outerHeight();
      $(this)
        .find(".swiper-next,.swiper-prev")
        .css("top", imgHeight / 2 - btnHeight / 2);
    });
  }, 100);
}
function replaceSvg() {
  $("img.svg").each(function () {
    var $img = $(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");
    $.get(
      imgURL,
      function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = $(data).find("svg");

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr("xmlns:a");

        // Replace image with new SVG
        $img.replaceWith($svg);
      },
      "xml"
    );
  });
}
function adjustProductAmount() {
  $(".plus").on("click", function () {
    $(this)
      .parents(".amount,.amount-2")
      .find(".input")
      .val(+$(this).parents(".amount,.amount-2").find(".input").val() + 1);
    $(".woocommerce-cart-form .update-cart.btn").removeAttr("disabled");
  });
  $(".minus").click(function () {
    if ($(this).parents(".amount,.amount-2").find(".input").val() > 1) {
      if ($(this).parents(".amount,.amount-2").find(".input").val() > 1)
        $(this)
          .parents(".amount,.amount-2")
          .find(".input")
          .val(+$(this).parents(".amount,.amount-2").find(".input").val() - 1);
    }
  });
}
function fixedNav() {
  var nav = $(".header");
  if (nav.length) {
    var offsetTop = nav.offset().top,
      TH = $(".header").height(),
      headerHeight = nav.height(),
      injectSpace = $("<div />", {
        height: headerHeight,
      }).insertAfter(".header");
    injectSpace.hide();
    $(window).on("load scroll resize", function () {
      if ($(window).scrollTop() > offsetTop) {
        nav.addClass("fixed");
        injectSpace.show();
      } else {
        nav.removeClass("fixed");
        injectSpace.hide();
      }
    });
  }
}
function sidebarDropdown() {
  //mega menu
  $(document).on("click", ".sidebar .icon-dropdown", function (event) {
    event.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).parent().next(".nav-sub").slideUp(200);
    } else {
      $(".sidebar .icon-dropdown").removeClass("active");
      $(this).addClass("active");
      $(".nav-sub").slideUp(200);
      $(this).parent().next(".nav-sub").slideDown(200);
    }
  });
  $(document).on("click", ".sidebar-mb-filter", function () {
    $(this).toggleClass("active");
    $(".sidebar-inner").slideToggle();
  });
}

$(window).resize(checkWidth).trigger("resize");
$(document).ready(function () {
  App.Init();
  InitSlider();
  replaceSvg();
  Headers();
  mappings();
  selectUi();
  fixedNav();
  adjustProductAmount();
  accordion();
  jarallax();
  myTabs();
  checkWidth();
  $("[data-fancybox]").fancybox({
    closeExisting: true,
    loop: true,
    touch: false,
    afterLoad: function () {
      $(".slider-1").slick("setPosition", 0);
    },
  });
  $('[data-fancybox="images"]').fancybox({
    baseClass: "myFancyBox",
    thumbs: {
      autoStart: true,
      axis: "x",
    },
  });
});
